import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/account/zeelool-rewards/m.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/account/zeelool-rewards/pc.tsx");
